import { render, staticRenderFns } from "./UserProfileAP.vue?vue&type=template&id=9357d6d0&scoped=true&"
import script from "./UserProfileAP.vue?vue&type=script&lang=js&"
export * from "./UserProfileAP.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileAP.vue?vue&type=style&index=0&id=9357d6d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9357d6d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9357d6d0')) {
      api.createRecord('9357d6d0', component.options)
    } else {
      api.reload('9357d6d0', component.options)
    }
    module.hot.accept("./UserProfileAP.vue?vue&type=template&id=9357d6d0&scoped=true&", function () {
      api.rerender('9357d6d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/AdminPage/UserProfileAP.vue"
export default component.exports